<template>
  <div class="verification-notice">
    <h1>{{ $t(`Email Verification Required`) }}</h1>
    <p class="email-desc">
      {{ $t(`Please check your email for a verification link. You must verify your email before you can continue.`) }}
    </p>
    <button class="button email-button" @click="resendVerificationEmail">
      {{ $t(`Resend Verification Email`) }}
    </button>
    <button class="button email-button" @click="$emit('logout')">
      {{ $t(`Logout`) }}
    </button>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import axios from '@/axios'
import { useToast } from 'vue-toastification'

export default defineComponent({
  emits: ['logout'],
  name: 'EmailVerificationNotice',

  data() {
    return {
      toast: null,
    }
  },

  created() {
    this.toast = useToast()
  },

  methods: {
    resendVerificationEmail() {
      axios.post( 'email/verify/resend')
          .then((res) => {
            this.toast.success(res.data.message || 'Verification email sent!')
          })
          .catch(() => {
            this.toast.error('Failed to send verification email.')
          })
    }
  },
})
</script>

<style scoped>
.verification-notice {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 50px;
  min-height: 80vh;
  color: #000;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
  padding: 20px;
}

.verification-notice > h1 {
  font-family: 'IBM Plex Sans KR', sans-serif;
}

.email-button {
  display: flex;
  text-decoration: none;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  max-width: 300px;
  font-family: 'IBM Plex Sans KR', sans-serif;
}

.email-desc {
  line-height: 20px;
  text-align: center;
  font-family: 'IBM Plex Sans KR', sans-serif;
}
</style>
